/**
 * タイル表示の高さ揃え処理を初期化する
 */
$(function() {
	$(".js-tile-col-rank-1").tile();
	$(".js-tile-col-rank-2").tile();
	$(".js-tile-col-rank-3").tile();
	$(".js-tile-col-rank-4").tile();
	$(".js-tile-col-rank-5").tile();
});
